import { render, staticRenderFns } from "./OverlayPop.vue?vue&type=template&id=804da778&scoped=true&"
import script from "./OverlayPop.vue?vue&type=script&lang=js&"
export * from "./OverlayPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804da778",
  null
  
)

export default component.exports